export default "/images/framework/PuzzleChase.397862af.svg?397862af";